module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-construction-b4abead70a9f6fad052e772f85d83b93.svg";